import moment from 'moment'

// El historial solicitado usa UTC-3 fijo; los timestamps siguen almacenados en UTC.
export const formatMovementHistoryTime = value => {
  if (value === null || value === undefined || value === '') return '—'
  const timestamp = Number(value)
  if (!Number.isFinite(timestamp)) return '—'
  return moment.utc(timestamp).utcOffset(-180).format('DD/MM/YYYY - HH:mm')
}
